import React from 'react';
import { Filter as FilterAdmin, TextInput, SelectInput } from 'react-admin';

import { STATUS_ATIVO, STATUS_INATIVO } from '../../utils';

const choices = [
  { id: STATUS_ATIVO, name: 'Ativo' },
  { id: STATUS_INATIVO, name: 'Inativo' },
];

const Filter = (props) => (
  <FilterAdmin {...props}>
    <TextInput label="Descrição" source="descricao" />
    <SelectInput
      source="status"
      choices={choices}
      label="Status"
      allowEmpty={false}
    />
  </FilterAdmin>
);

export default Filter;
